import {appAPI} from "../../../api";

export interface IBillingStatus {
    status: 'active' | 'grace' | 'restricted';
    threshold_warning: 1 | 2 | 3 | null;
    forecast_days: number | null;
    is_enabled: boolean;
    balance: number;
    credit_limit: number;
    daily_cost: number;
    unit: string;
    blocked_at: string | null;
    // Эти поля приходят из BalanceInfoDto, но в слайсе билинга мы их пока не храним.
    // Если понадобятся в UI — добавишь сюда и в слайс одновременно.
    active_trackers?: number;
    total_trackers?: number;
    tariff_name?: string;
    tariff_price?: number;
    discount?: number;
    price_per_tracker?: number;
}

export const billingAPI = {
    getStatus: async (): Promise<IBillingStatus> => {
        const res = await appAPI.get('/companies/balance-info', {
            _skipBillingHandler: true,
        });
        return res.data;
    },
};